import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import HelmetErrorBoundary from "./components/HelmetErrorBoundary";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetErrorBoundary>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </HelmetErrorBoundary>
  </React.StrictMode>,
);
